import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {PageTitleComponent} from '@shared/components/page-title/page-title.component';
import {TranslatePipe} from '@ngx-translate/core';
import {NgClass, NgIf} from '@angular/common';
import { ChartComponent} from "ng-apexcharts";
import {ModalClose} from '@shared/services/modal/modal.enum';
import {MeterFormComponent} from '@modules/settings/meters/meter-form/meter-form.component';
import {SmartMeterService} from '@modules/universal-billing/smart-meter/smart-meter.service';
import {MeterCardComponent} from '@modules/universal-billing/smart-meter/components/meter-card/meter-card.component';
import {SkeletonModule} from '@primeng/skeleton';
import {
  CounterDetails
} from '@modules/universal-billing/meters/counter-details/counter-details';
import { BaseLoadComponent } from '@shared/components/classes/base-load.component';
import { ChartOptions } from '@shared/third-part-modules/apex-chart/chart-options.type';
import { Observable } from 'rxjs';
import { ModalService } from '@shared/services/modal/modal.service';
import { UnitTypesService } from '@modules/settings/unit-types/unit-types.service';
import { FigmaIconComponent } from '@shared/components/figma-icon/figma-icon.component';
import { UnitTypeDirective } from '@common/directive/unit-type.directive';

@Component({
  selector: 'app-smart-meter',
  standalone: true,
  imports: [
    PageTitleComponent,
    TranslatePipe,
    NgClass,
    ChartComponent,
    MeterCardComponent,
    NgIf,
    SkeletonModule,
    FigmaIconComponent,
    UnitTypeDirective
  ],
  templateUrl: './smart-meter.component.html',
  styleUrl: './smart-meter.component.scss'
})
export class SmartMeterComponent extends BaseLoadComponent<any> implements OnInit {
  service = inject(SmartMeterService);
  unitTypeService = inject(UnitTypesService);
  modalService = inject(ModalService);
  public breadCrumbItems = [];
  filter = 'all';
  unitTypes = [];
  activeTab: string | null = null;

  getData(): Observable<any> {
    return  this.service.getAll(this.activeTab ? {unitTypeId: this.activeTab} : {});
  }

  setActiveTab(tab = null) {
    this.activeTab = tab;
    this.loadData();
  }

  setActiveFilter(filter: string) {
    this.filter = filter;
  }

  ngOnInit() {
    super.ngOnInit();

    this.breadCrumbItems = [
      { label: 'MENU.UNIVERSAL_BILLING', iconClass: 'las la-settings' },
      { label: 'MENU.SMART_METERS', active: true }
    ];

    this.unitTypeService.getAll().subscribe(({ data }) => {
      this.unitTypes = data;
    });
  }
  onAdd() {
    const translated = this.translateService.instant('METER.ADD_COUNTER')
    this.modalService.open({
      component: MeterFormComponent,
      title: `${translated}`,
      componentOptions: {},
      modalOptions: {
        size:"lg"
      }
    }).then(
      (res) => {
        if (res == ModalClose.SUCCESS) {
          this.loadData()
        }
      }
    )
  }

  getMetersCount(data) {
    if (this.filter == 'main') {
      return data['ownMeters'].length;
    } else if (this.filter == 'unit') {
      return data['apartments'].reduce((count, obj) => count + obj.meters.length, 0);
    } else if (this.filter == 'all') {
      return data['ownMeters'].length + data['apartments'].reduce((count, obj) => count + obj.meters.length, 0)
    }
  }

  showMeterDetails(data) {
    const translated = this.translateService.instant('PROPERTY.COUNTER_DETAILS')
    this.modalService.open({
      component: CounterDetails,
      title: `${translated}`,
      componentOptions: {
        meter: data,
      },
      modalOptions: {}
    });
  }
}
